import $ from 'jquery';
import Swiper from 'swiper';
import { Autoplay, EffectFade, Controller, Navigation, Pagination, HashNavigation } from 'swiper/modules';
import { gsap } from 'gsap';
import { Draggable } from 'gsap/Draggable';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { $Elements, Durations, Events, Classes } from './constants';
import GLightbox from 'glightbox';

$Elements.document.on(Events.page.enter, () => {

	// ---------- Slider for Articles ----------

	$('.other-posts-section .section-carousel').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.animations.ms,
				loop: false,
				observer: true,
				grabCursor: true,
				watchSlidesProgress: true,
				centerInsufficientSlides: true,
				slideToClickedSlide: true,
				slidesPerView: 'auto',
			});
		}
	});

	// ---------- slider-single-wine Carousel ----------

	$('.slider-single-wine .section-carousel').each(function() {

		const carousel = this;
		const vintages = document.querySelector('.aside .vintage-list');

		const slides = document.querySelectorAll('.swiper-slide');

		if(slides) {
			slides.forEach((slide) => {
				const background = slide.querySelector('.hero-wine-column');

				if(background && background.hasAttribute('data-vintage')) {
					const vintage = background.getAttribute('data-vintage');
					slide.setAttribute('data-hash', vintage);
				}
			});
		}


		if(carousel && vintages) {

			let vintagesSwiper = null;
			let mainSwiper = null;

			if(!vintages.swiper) {

				vintagesSwiper = new Swiper(vintages, {
					modules: [Controller, Navigation],
					direction: 'horizontal',
					speed: Durations.animations.ms,
					loop: false,
					observer: true,
					grabCursor: true,
					watchSlidesProgress: true,
					centerInsufficientSlides: false,
					slidesPerView: 'auto',
					draggable: true,
					allowTouchMove: true,
					breakpoints: {
						1024: {
							direction: 'vertical',
							centerInsufficientSlides: true,
						}
					},

					on: {
						afterInit: swiper => {
							$(swiper.el).find('.swiper-slide:first-child').addClass(Classes.active);
							$(swiper.el).find('.swiper-slide').each(function(index) {

								$(this).on('click', () => {
									$(swiper.el).find('.swiper-slide').removeClass(Classes.active);
									$(this).addClass(Classes.active);

									if(mainSwiper) {
										mainSwiper.slideTo(index);
									}
								});
							});
						}
					}
				});
			}

			if(!carousel.swiper) {

				mainSwiper = new Swiper(carousel, {
					speed: Durations.animations.ms * 1.5,
					loop: false,
					hashNavigation: {
						replaceState: true,
					},
					observer: true,
					autoHeight: true,
					modules: [Navigation, Pagination, Controller, HashNavigation],
					breakpoints: {
						1024: {
							allowTouchMove: false,
						},
					},

					fadeEffect: {
						crossFade: true,
					},
					navigation: {
						prevEl: document.querySelector('.swiper-button-prev'),
						nextEl: document.querySelector('.swiper-button-next'),
					},
					on: {
						slideChangeTransitionEnd: function() {
							ScrollTrigger.refresh();
						},
						resize: function() {
							ScrollTrigger.refresh();
						},
						activeIndexChange: swiper => {

							if(vintagesSwiper) {
								$(vintagesSwiper.el).find('.swiper-slide').removeClass(Classes.active);
								$(vintagesSwiper.el).find('.swiper-slide:nth-child(' + (swiper.activeIndex + 1) + ')').addClass(Classes.active);
							}
						}
					}
				});
			}
		}

		//Background
		const backgroundNumber = document.querySelectorAll('.background p');

		backgroundNumber.forEach((number) => {
			const numberString = number.textContent;
			const parent = number.parentNode;

			parent.removeChild(number);

			numberString.split('').forEach((char) => {
				const splitNumber = document.createElement('p');
				splitNumber.textContent = char;
				parent.appendChild(splitNumber);
			});
		});

	});


	// ---------- Slideshow ----------

	$('.content-section.section-slideshow, .content-section .column-slideshow').each(function() {

		if(!this.swiper) {

			const swiper = new Swiper(this, {
				speed: Durations.animations.ms,
				loop: true,
				observer: true,
				autoplay: true,
				effect: 'fade',
				modules: [Autoplay, EffectFade, Navigation, Pagination],
				fadeEffect: {
					crossFade: true,
				},
				pagination: {
					el: this.querySelector('.swiper-pagination'),
				},
				navigation: {
					nextEl: this.querySelector('.swiper-button-next'),
					prevEl: this.querySelector('.swiper-button-prev'),
				},
			});
		}
	});

	// ---------- Map Section ----------

	$('.map-section').each(function() {

		let mapContainer = this.querySelector('.map-container'),
			mapContainerX = gsap.quickSetter(mapContainer, 'x', 'px'),
			mapContainerY = gsap.quickSetter(mapContainer, 'y', 'px'),
			miniMap = this.querySelector('.mini-map'),
			miniMapMarker = this.querySelector('.mini-map-marker'),
			miniMapMarkerX = gsap.quickSetter(miniMapMarker, 'x', 'px'),
			miniMapMarkerY = gsap.quickSetter(miniMapMarker, 'y', 'px'),
			imageScale;

		const setupSizing = () => {

			imageScale = miniMap.offsetWidth / mapContainer.offsetWidth;

			let screenToBigRatio = window.innerWidth / mapContainer.offsetWidth,
				aspectRatio = window.innerWidth / window.innerHeight;

			gsap.set(miniMapMarker, {
				width: screenToBigRatio * miniMap.offsetWidth,
				height: screenToBigRatio * miniMap.offsetWidth / aspectRatio
			});
		};

		const alignMiniMapMarker = () => {
			miniMapMarkerX(-mapContainerDraggable.x * imageScale);
			miniMapMarkerY(-mapContainerDraggable.y * imageScale);
		};

		const alignMapContainer = () => {
			mapContainerX(-miniMapMarkerDraggable.x / imageScale);
			mapContainerY(-miniMapMarkerDraggable.y / imageScale);
		};

		const initMap = () => {
			setupSizing();
			mapContainerDraggable.update();
			alignMiniMapMarker();
		};

		let miniMapMarkerDraggable = Draggable.create(miniMapMarker, {
			bounds: miniMap,
			onDrag: alignMapContainer,
			onThrowUpdate: alignMapContainer,
			inertia: true
		})[0];

		let mapContainerDraggable = Draggable.create(mapContainer, {
			bounds: window,
			onDrag: alignMiniMapMarker,
			onThrowUpdate: alignMiniMapMarker,
			inertia: true
		})[0];

		gsap.set(mapContainer, {
			x: (mapContainerDraggable.minX + mapContainerDraggable.maxX) / 2,
			y: (mapContainerDraggable.minY + mapContainerDraggable.maxY) / 2
		});

		window.addEventListener('resize', initMap);
		initMap();
	});


	// ---------- Glightbox to members ----------
	$('.equipe-section').each(function() {

		const lightbox = GLightbox({
			selector: '.glightbox a',
			touchNavigation: true,
			loop: false,
			zoomable: true,
			inline: {
				allowFullscreen: false
			}
		});

		const lightboxLinks = document.querySelectorAll('.glightbox a');

		lightboxLinks.forEach(function(link) {
			link.addEventListener('click', function(event) {
				const container = document.querySelector('.gcontainer');
				if(container) {
					container.setAttribute('data-lenis-prevent', '');
				}

				const buttonClose = document.querySelector('.gclose');
				if(buttonClose) {
					buttonClose.innerHTML += 'Fermer';
				}
			});
		});
	})

});
